<template>
  <!-- PC화면 문의-->
  <div id="contact-us"
    class="hidden lg:flex lg:w-[1280px] mx-auto my-10 justify-between">
    <div class="flex flex-col items-start leading-[52px] tracking-[-0.0045em]">
      <p v-if="title" class="text-[36px] text-main-0 font-bold">{{ title }}</p>
      <p class="text-[36px] text-text-0 font-bold">지금 바로 문의해 주세요.</p>
      <div class="flex flex-col leading-loose mt-2 text-small-size font-medium text-gray">
        <p v-if="description" class="">{{ description }}</p>
        <p>평일 1일 내, 빠른 답변드립니다.</p>
        <p>전화 상담을 원하신다면 <span class="font-bold text-main-0">02-6953-8506</span> 으로 연락부탁드립니다.</p>
      </div>
    </div>
    <div class="">
      <form class="flex flex-col w-[640px] gap-6" @submit.prevent="submitInquiry"
        action="https://script.google.com/macros/s/AKfycbxkSLWI8SErbff6Pw5IQWLlnTyHhM4MyWhwGomlUA7TJ-VdJdVD7Zpzd3v_5Du538BE/exec">
        <div class="flex justify-between">
          <!--회사명-->
          <div class="flex w-[300px] items-center justify-between">
            <p class="text-text-0 text-small-size">회사명<span class="text-[#FF5252]">&nbsp;*</span></p>
            <input id="companyName" v-model="form.companyName"
              class="w-[216px] h-[50px] pl-4 border-[1px] rounded-lg border-gray_3 focus:border-main-0 placeholder:text-small-size-1 outline-none"
              type="text" placeholder="회사명을 입력해주세요.">
          </div>
          <!--이름-->
          <div class="flex w-[300px] items-center justify-between">
            <p class="text-text-0 text-small-size">이름<span class="text-[#FF5252]">&nbsp;*</span></p>
            <input
              class="w-[216px] h-[50px] pl-4 border-[1px] rounded-lg border-gray_3 focus:border-main-0 placeholder:text-small-size-1 outline-none"
              id="name" v-model="form.name" type="text" placeholder="이름을 입력해주세요.">
          </div>
        </div>

        <div class="flex justify-between">

          <!-- 이메일 -->
          <div class="flex w-[300px] items-center justify-between">
            <p class="text-text-0 text-small-size">이메일<span class="text-[#FF5252]">&nbsp;*</span></p>
            <input id="email" v-model="form.email"
              class="w-[216px] h-[50px] pl-4 border-[1px] rounded-lg border-gray_3 focus:border-main-0 placeholder:text-small-size-1 outline-none"
              type="email" placeholder="이메일을 입력해주세요.">
          </div>

          <!-- 직급 -->
          <div class="flex w-[300px] items-center justify-between">
            <p class="text-text-0 text-small-size">직급<span class="text-[#FF5252]">&nbsp;*</span></p>
            <input id="position" v-model="form.position"
              class="w-[216px] h-[50px] pl-4 border-[1px] rounded-lg border-gray_3 focus:border-main-0 placeholder:text-small-size-1 outline-none"
              type="name" placeholder="직급을 입력해주세요.">
          </div>

        </div>

        <!-- 문의경로 -->
        <div class="flex justify-between items-center">
          <p class="text-text-0 text-small-size">문의경로<span class="text-[#FF5252]">&nbsp;*</span></p>
          <select id="channel" v-model="form.channel"
            class="w-[556px] h-[50px] pl-4 border-[1px] rounded-lg border-gray_3 focus:border-main-0 placeholder:text-small-size-1 outline-none">
            <option class="text-main-0" value="" disabled selected>선택해주세요</option>
            <option value="구글">구글</option>
            <option value="네이버">네이버</option>
            <option value="AI 검색">AI 검색</option>
            <option value="컨퍼런스">컨퍼런스</option>
            <option value="언론보도">언론보도</option>
            <option value="DM 이메일">DM 이메일</option>
            <option value="지인추천">지인추천</option>
          </select>
        </div>

        <!-- 서비스 -->
        <div v-if="isShowplatform" class="flex justify-between items-center">
          <p class="text-text-0 text-small-size">서비스<span class="text-[#FF5252]">&nbsp;*</span></p>
          <select id="platform" v-model="form.platform"
            class="w-[556px] h-[50px] pl-4 border-[1px] rounded-lg border-gray_3 focus:border-main-0 placeholder:text-small-size-1 outline-none">
            <option class="text-main-0" value="" disabled selected>선택해주세요</option>
            <option value="3">Q-Meet</option>
            <option value="1">Testing Service</option>
            <option value="2">Development</option>
          </select>
        </div>

        <!-- 문의제목 -->
        <div class="flex justify-between items-center">
          <p class="text-text-0 text-small-size">문의제목<span class="text-[#FF5252]">&nbsp;*</span></p>
          <input id="title" v-model="form.title"
            class="w-[556px] h-[50px] pl-4 border-[1px] rounded-lg border-gray_3 focus:border-main-0 placeholder:text-small-size-1 outline-none"
            type="text" placeholder="문의하실 제목을 입력해주세요.">
        </div>

        <!-- 문의내용 -->
        <div class="flex justify-between items-center">
          <p class="text-text-0 text-small-size">문의내용<span class="text-[#FF5252]">&nbsp;*</span></p>
          <textarea id="question" v-model="form.question"
            class="w-[556px] h-28 pl-4 py-3 border-[1px] rounded-lg border-gray_3 focus:border-main-0 placeholder:text-small-size-1 outline-none"
            type="text" placeholder="문의하실 내용을 입력해주세요."></textarea>
        </div>

        <!-- 휴대전화 -->
        <div class="flex justify-between items-center">
          <p class="text-text-0 text-small-size">휴대전화<span class="text-[#FF5252]">&nbsp;*</span></p>
          <input id="phone" v-model="form.phone"
            class="w-[556px] h-[50px] pl-4 border-[1px] rounded-lg border-gray_3 focus:border-main-0 placeholder:text-small-size-1 outline-none"
            type="tel" placeholder="휴대폰 번호를 입력해주세요.">
        </div>

        <!-- 개인정보 동의 -->
        <div class="flex justify-end">
          <input class="w-6 h-6 mr-4" type="checkbox" v-model="form.agreement">
          <p class="text-text-0 mr-2">(필수) 개인정보 제 3자 제공에 동의합니다.</p>
          <button class="text-gray text-small-size-1 underline decoration-gray"
            @click="goToPage('/terms')">상세보기</button>
        </div>

        <!-- 문의하기 -->
        <div id="contact-us" class="flex justify-end">
          <button class="rounded-full items-center justify-center bg-main-0 px-8 h-[44px] cursor-pointer text-center">
            <p class="text-white">문의하기</p>
          </button>
          <div
            :class="[isLoading ? 'ml-4 w-8 h-8 border-4 border-main-0 border-t-transparent rounded-full animate-spin' : '']">
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- 모바일 화면 문의-->
  <div class="flex flex-col px-5 py-10 mx-auto lg:hidden">
    <div class="flex flex-col">
      <p class="text-main-0 font-bold text-medium-size-1">{{ title }}</p>
      <p class="font-bold text-text-0 text-medium-size-2">지금 바로 문의해 주세요.</p>
      <div class="font-medium text-gray text-small-size-1 mt-2">
        <p v-if="description" class="">{{ description }}</p>
        <p>평일 1일 내, 빠른 답변드립니다.</p>
        <p>전화 상담을 원하신다면 <span class="font-bold text-main-0">02-6953-8506</span> 으로 연락부탁드립니다.</p>
      </div>
    </div>
    <form class="flex flex-col gap-6 mt-5" @submit.prevent="submitInquiry"
      action="https://script.google.com/macros/s/AKfycbxkSLWI8SErbff6Pw5IQWLlnTyHhM4MyWhwGomlUA7TJ-VdJdVD7Zpzd3v_5Du538BE/exec">
      <div class="flex justify-between items-center gap-4">
        <p class="font-medium text-small-size text-text-0 w-[100px]">회사명<span class="text-[#FF5252]">&nbsp;*</span></p>
        <input id="companyName" v-model="form.companyName"
          class="w-full h-[42px] pl-4 border border-gray_3 rounded-lg outline-none" type="text"
          placeholder="회사명을 입력해주세요.">
      </div>
      <div class="flex justify-between items-center gap-4">
        <p class="font-medium text-small-size text-text-0 w-[100px]">이름<span class="text-[#FF5252]">&nbsp;*</span></p>
        <input id="name" v-model="form.name"
          class="w-full h-[42px] pl-4 border border-gray_3 rounded-lg outline-none" type="text"
          placeholder="이름을 입력해주세요.">
      </div>
      <div class="flex justify-between items-center gap-4">
        <p class="font-medium text-small-size text-text-0 w-[100px]">직급<span class="text-[#FF5252]">&nbsp;*</span></p>
        <input id="position" v-model="form.position"
          class="w-full h-[42px] pl-4 border border-gray_3 rounded-lg outline-none" type="text"
          placeholder="직급을 입력해주세요.">
      </div>
      <div class="flex justify-between items-center gap-4">
        <p class="font-medium text-small-size text-text-0 w-[100px]">이메일<span class="text-[#FF5252]">&nbsp;*</span></p>
        <input id="email" v-model="form.email"
          class="w-full h-[42px] pl-4 border border-gray_3 rounded-lg outline-none" type="email"
          placeholder="이메일을 입력해주세요.">
      </div>

      <div class="flex justify-between items-center gap-4">
        <p class="font-medium text-small-size text-text-0 w-[100px]">문의경로<span class="text-[#FF5252]">&nbsp;*</span></p>
        <select id="channel" v-model="form.channel"
          class="w-full h-[42px] pl-4 border border-gray_3 rounded-lg outline-none">
          <option class="text-main-0" value="" disabled selected>선택해주세요</option>
          <option value="구글">구글</option>
          <option value="네이버">네이버</option>
          <option value="AI 검색">AI 검색</option>
          <option value="컨퍼런스">컨퍼런스</option>
          <option value="언론보도">언론보도</option>
          <option value="DM 이메일">DM 이메일</option>
          <option value="지인추천">지인추천</option>
        </select>
      </div>

      <div v-if="isShowplatform" class="flex justify-between items-center gap-4">
        <p class="font-medium text-small-size text-text-0 w-[100px]">서비스<span class="text-[#FF5252]">&nbsp;*</span></p>
        <select id="platform" v-model="form.platform"
          class="w-full h-[42px] pl-4 border border-gray_3 rounded-lg outline-none">
          <option class="text-main-0" value="" disabled selected>선택해주세요</option>
          <option value="3">Q-Meet</option>
          <option value="1">Testing Service</option>
          <option value="2">Development</option>
        </select>
      </div>

      <div class="flex justify-between items-center gap-4">
        <p class="font-medium text-small-size text-text-0 w-[100px]">문의제목<span class="text-[#FF5252]">&nbsp;*</span></p>
        <input id="title" v-model="form.title"
          class="w-full h-[42px] pl-4 border border-gray_3 rounded-lg outline-none" type="text"
          placeholder="문의하실 제목을 입력해주세요.">
      </div>
      <div class="flex justify-between items-center gap-4">
        <p class="font-medium text-small-size text-text-0 w-[100px]">문의내용<span class="text-[#FF5252]">&nbsp;*</span></p>
        <textarea id="question" v-model="form.question"
          class="w-full h-20 py-3 pl-4 border border-gray_3 rounded-lg outline-none" type="text"
          placeholder="문의하실 내용을 입력해주세요."></textarea>
      </div>
      <div class="flex justify-between items-center gap-4">
        <p class="font-medium text-small-size text-text-0 w-[100px]">휴대전화<span class="text-[#FF5252]">&nbsp;*</span></p>
        <input id="phone" v-model="form.phone"
          class="w-full h-[42px] pl-4 border border-gray_3 rounded-lg outline-none" type="tel"
          placeholder="휴대폰 번호를 입력해주세요.">
      </div>
      <div class="flex justify-start items-center">
        <input class="w-5 h-5 mr-[10px]" type="checkbox" v-model="form.agreement">
        <p class="text-text-0 leading-5 text-small-size-1 mr-2">(필수) 개인정보 제 3자 제공에 동의합니다.</p>
        <button class="text-gray text-small-size-1 underline decoration-gray" @click="goToPage('/terms')">상세보기</button>
      </div>
      <div id="contact-us" class="flex mx-auto">
        <button
          class="px-6 h-[44px] rounded-full flex items-center justify-center bg-main-0 cursor-pointer mt-4 text-center">
          <p class="text-white text-small-size-1">문의하기</p>
        </button>
        <div
          :class="[isLoading ? 'ml-4 w-8 h-8 border-4 border-main-0 border-t-transparent rounded-full animate-spin' : '']">
        </div>
      </div>
    </form>
  </div>

</template>

<script>
export default {
  props: {
    qnaData: {
      type: Object,
      required: true,
    },
    isShowplatform: {
      type: Boolean,
      required: false,
    },
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    propPlatform: {
      type: [String, Number], // 데이터 타입에 따라 수정
      required: false, // 필수가 아니라면 false      
    },
  },

  methods: {
    toggleSelection(item) {
      this.selectedItem = this.selectedItem === item ? null : item;
    },
    goToPage(path) {
      this.$router.push(path)
    },
    submitInquiry() {

      if (!this.isFormValid) {
        console.log("submitInquiry 1");
        alert('필수 항목을 모두 입력해주세요.');
        return;
      }


      this.isLoading = true; // 로딩 시작
      // 폼 데이터를 URL 인코딩된 형태로 준비


      if (this.isShowplatform) {
        if (this.form.platform == '1')
          this.form.platform = "Testing Service";        
        else if (this.form.platform == '3')
          this.form.platform = "Q-Meet";
        else if (this.form.platform == '2')
          this.form.platform = 'Development'
      }
      else {
        if (this.propPlatform == '1') {
          this.form.platform = "Testing Service";
        }        
        else if (this.propPlatform == '3') {
          this.form.platform = "Q-Meet";
        } else if (this.propPlatform == '2') {
          this.form.platform = 'Development';
        }
      }

      const formData = new URLSearchParams();
      Object.keys(this.form).forEach(key => {
        formData.append(key, this.form[key]);
      });

      // Google Apps Script URL
      const scriptURL = 'https://script.google.com/macros/s/AKfycbzDD7CZF4MUmIn_ox3doBNWPxnCMzVV3Jx2cixVaaKfNF5qwRJCbrWb425-gGLhIh3E/exec';

      // 폼 데이터 전송
      fetch(scriptURL, {
        method: 'POST',
        body: formData,
        mode: 'no-cors'
      })
        .then(response => {
          console.log('Success!', response);
          this.formSubmitted = true;
          alert('빠른시일 내에 답변 드리도록 하겠습니다. 감사합니다.');
          gtag('event', 'conversion', {
            'send_to': 'AW-16592420747/c0RsCNeXv8oZEIv_8Oc9',
            'value': 10.0,
            'currency': 'KRW'
          });
          this.resetForm();
        })
        .catch(error => {
          console.error('Error!', error.message);
        })
        .finally(() => {
          this.isLoading = false; // 로딩 종료
        });
    },
    resetForm() {
      this.form = {
        companyName: '',
        email: '',
        phone: '',
        platform: '',
        position: '',
        question: '',
        title: '',
        agreement: false,
        name: '',
        channel: '',
      };
    }

  },

  computed: {
    filteredList() {
      return this.questions.filter((q) => q.category === this.currentTab);
    },
    isFormValid() {
      console.log(this.form);
      console.log(this.form.companyName);
      if (!this.propPlatform)
        return this.form.companyName && this.form.email && this.form.position && this.form.phone && this.form.platform && this.form.title && this.form.question && this.form.agreement && this.form.channel;
      else
        return this.form.companyName && this.form.email && this.form.phone && this.form.position && this.form.title && this.form.question && this.form.agreement && this.form.channel;
    }
  },

  data() {
    return {
      isLoading: false, // 로딩 상태 추가
      form: {
        companyName: '',
        name: '',
        email: '',
        platform: '',
        position: '',
        phone: '',
        question: '',
        title: '',
        agreement: false,
        channel: '',
      },
      formSubmitted: false,
    }
  },
  mounted() {

        console.log('111');
        gtag('event', 'conversion', {
            'send_to': 'AW-16592420747/c0RsCNeXv8oZEIv_8Oc9',
            'value': 10.0,
            'currency': 'KRW'
        });
    
  },
}
</script>

<style scoped>
.placeholder-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>